(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('TemplatesController', TemplatesController);

  /* ngInject */
  function TemplatesController($stateParams, config) {
    const vm = this;

    vm.config = config;
    vm.templates = [];

    activate();

    function activate() {
      getTemplates();
    }

    function getTemplates() {}
  }
})();
